import ImportProductsRequestModelBase from '../_generated/modelBases/import-products-request-model-base';

export default class ImportProductsRequestModel extends ImportProductsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
